@if (vm$ | async; as vm) {
    @if (vm.isVisible) {
        <bs-reward-tokens-selector
            [selectedToken]="vm.selectedToken ?? undefined"
            [infoEnabled]="infoEnabled"
            [isTokenInvalid]="vm.isTokenInvalid"
            [hasAcquisitionOnboarding]="vm.hasAcquisitionOnboarding"
            (selectorClick)="onSelectorClick()"
            (infoClick)="onInfoClick()" />
    }
}
